const form = $('#commentform');

export const FormCommentOptions = {
  form,
  modalMessage: true,
  customSubmitHandler: false,
  dataToRdStation: []
}